<template>
  <v-app-bar
    hide-on-scroll
    elevate-on-scroll
    scroll-threshold="100"
    color="white"
    height="176px"
    app
    class="header"
  >
    <v-sheet
      width="100%"
      class="sub-header d-flex align-center"
      color="primary"
      height="56px"
    >
      <v-container class="d-flex justify-space-between">
        <div class="sub-header-addrress">
          <v-btn
            class="white--text text-none"
            text
            target="_blank"
            :href="informations.google_maps"
          >
            <v-icon class="mr-2" size="20" color="white"
              >fas fa-map-marker-alt</v-icon
            >
            {{ informations.address }}
          </v-btn>
        </div>
        <div class="social">
          <v-btn
            v-for="({ link, icon, size }, i) in informationsContacts"
            :key="i"
            class="ml-2"
            color="white"
            target="_blank"
            text
            rounded
            height="33px"
            width="33px"
            icon
            :href="link"
          >
            <v-icon color="white" :size="size">{{ icon }}</v-icon>
          </v-btn>
          <v-btn
            class="white--text text-none ml-4"
            rounded
            depressed
            color="primary lighten-2"
            target="_blank"
            :href="getWhatsappLinkFromPhone(informations.whatsapp)"
          >
            <v-icon class="mr-2" size="20" color="white">fa-whatsapp</v-icon>
            {{ informations.whatsapp }}
          </v-btn>
        </div>
      </v-container>
    </v-sheet>
    <v-container class="py-0 h-100">
      <v-sheet
        width="100%"
        height="100%"
        color="transparent"
        class="d-flex justify-space-between align-center"
      >
        <router-link to="/">
          <img
            v-if="informations.img"
            :src="files + informations.img"
            :alt="informations.name"
            class="d-block"
            height="97px"
          />
        </router-link>

        <div class="d-flex align-center">
          <div>
            <div
              v-for="({ text, to, dropdown }, keyMenu) in menu"
              :key="keyMenu"
              class="d-inline-flex"
            >
              <v-btn
                v-if="!dropdown"
                class="
                  text-caption text-lg-body-1 text-none
                  font-weight-medium
                  px-2 px-lg-3
                  py-5
                  nav-link
                  primary--text
                "
                v-bind="getLinkAttrs(to)"
                active-class="nav-link-active"
                tile
                depressed
                text
              >
                {{ text }}
              </v-btn>

              <v-menu v-else offset-y tile>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    class="
                      text-caption text-lg-body-1 text-none
                      font-weight-medium
                      px-2 px-lg-3
                      py-5
                      nav-link
                    "
                    active-class="nav-link-active"
                    tile
                    depressed
                    text
                  >
                    {{ text }}
                    <v-icon class="ml-3" size="12"> fa-caret-down </v-icon>
                  </v-btn>
                </template>
                <v-list tile>
                  <v-list-item
                    v-for="(item, keyDropdown) in dropdown"
                    :key="keyDropdown"
                    v-bind="getLinkAttrs(item.to)"
                  >
                    <v-list-item-title class="grey--text text--darken-3">
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </div>
        </div>
      </v-sheet>
    </v-container>
  </v-app-bar>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../../utils/getWhatsappLinkFromPhone";
import { getSocial } from "../../../utils/getSocial";
import { getLinkAttrs } from "../../../utils/getLinkAttrs";

export default {
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    informationsContacts() {
      return getSocial(this.$rest("informations").item);
    },
  },
  methods: {
    getWhatsappLinkFromPhone,
    getLinkAttrs,
  },
};
</script>

<style lang="scss" scoped>
.header::v-deep {
  .nav-link {
    &:before {
      opacity: 0 !important;
    }
  }
  .nav-link-active {
    color: var(--v-primary-lighten2) !important;
    background-color: transparent !important;
  }
  .v-toolbar__content {
    display: flex;
    padding: 0;
    flex-direction: column;
  }
  .h-100 {
    height: 100%;
  }
}
</style>
